interface ParsedReference {
  book: string;
  chapter: number;
  verse?: number;
}

export function parseReference(reference: string): ParsedReference {
  // Remove any leading/trailing whitespace
  reference = reference.trim();

  // Handle common reference formats
  // Examples: "John 3:16", "Genesis 1", "Psalm 23:1-6"
  const match = reference.match(/^(\d*\s*[A-Za-z]+)\s*(\d+)(?::(\d+))?/);

  if (!match) {
    console.warn(`Unable to parse reference: ${reference}`);
    return { book: '', chapter: 0 };
  }

  const [, book, chapter, verse] = match;

  // Clean up book name (remove numbers and extra spaces)
  const cleanBook = book.trim();

  return {
    book: cleanBook,
    chapter: parseInt(chapter),
    ...(verse ? { verse: parseInt(verse) } : {})
  };
}
